// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.digitalRev {
  background: #1d1a36;
  display: flex;
  justify-content: center;
  color: #fff;
  font-size: 3vw;
}
@media (max-width: 1024px) {
  .digitalRev {
    font-size: 5vw;
    padding-top: 7vw;
  }
}
@media (max-width: 992px) {
  .digitalRev {
    font-size: 7vw;
    padding-top: 7vw;
  }
}
@media (max-width: 768px) {
  .digitalRev {
    font-size: 7vw;
    padding-top: 7vw;
  }
}
@media (max-width: 576px) {
  .digitalRev {
    font-size: 8vw;
    padding-top: 7vw;
  }
}

.boxHeading {
  background: #1d1a36;
  display: flex;
  justify-content: center;
  color: #fff;
}

.headingParagraph {
  background: #1d1a36;
  display: flex;
  text-align: center;
  color: #fff;
  font-size: 1.3vw;
  line-height: 150%;
}
@media (max-width: 1200px) {
  .headingParagraph {
    font-size: 16px;
  }
}

.coreValues {
  background: #1d1a36;
  display: flex;
  justify-content: center;
  color: #fff;
  padding-bottom: 2.5vw;
}

.AboutUs_gradiantHeading {
  border: 1px solid transparent;
  border-image: linear-gradient(146deg, rgb(255, 182, 160) 0%, rgb(240, 89, 42) 26%, rgb(37, 60, 119) 100%);
  border-image-slice: 1;
  padding: 0.6rem;
  font-weight: 400;
  font-family: Roboto;
  font-size: 1.5vw;
  text-align: center;
  color: #fff;
}
@media (max-width: 1300px) {
  .AboutUs_gradiantHeading {
    font-size: 1.7vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 992px) {
  .AboutUs_gradiantHeading {
    font-size: 2vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 769px) {
  .AboutUs_gradiantHeading {
    font-size: 2.5vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
@media (max-width: 576px) {
  .AboutUs_gradiantHeading {
    font-size: 4vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}

.cardsAboutus {
  padding-top: 2vw;
  background: #1d1a36;
}

.missionText {
  background: #1d1a36;
  display: flex;
  text-align: center;
  color: #fff;
  padding: 3vw 5vw 2vw 5vw;
  line-height: 150%;
  font-size: 1.3vw;
}
@media (max-width: 1200px) {
  .missionText {
    font-size: 16px;
  }
}

.successAboutUs {
  width: 60vw !important;
  height: 30vw !important;
  flex-shrink: 0;
  border-radius: 20px;
  background: #1d1a36;
}

.NTAAboutUs {
  background: linear-gradient(270deg, rgba(255, 136, 96, 0) 0%, rgba(255, 190, 113, 0.4) 33.12%, rgba(255, 153, 101, 0.4) 52.4%, rgba(255, 225, 123, 0.4) 69.48%, rgba(255, 242, 129, 0) 100%) !important;
  width: 35vw !important;
  height: 0.14vh !important;
  margin: 1vh 0 6vh;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/Pages/AboutUs/aboutUs.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EAEA,cAAA;AAAF;AACE;EAPF;IAQI,cAAA;IACA,gBAAA;EAEF;AACF;AADE;EAXF;IAYI,cAAA;IACA,gBAAA;EAIF;AACF;AAHE;EAfF;IAgBI,cAAA;IACA,gBAAA;EAMF;AACF;AALE;EAnBF;IAoBI,cAAA;IACA,gBAAA;EAQF;AACF;;AALA;EAEE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAOF;;AAJA;EAIE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAIF;AAHE;EAVF;IAWI,eAAA;EAMF;AACF;;AAJA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;AAOF;;AAFE;EACE,6BAAA;EACA,yGAAA;EAMA,qBAAA;EACA,eAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AADJ;AAGI;EAjBF;IAkBI,gBAAA;IACA,mBAAA;IACA,oBAAA;EAAJ;AACF;AACI;EAtBF;IAuBI,cAAA;IACA,mBAAA;IACA,oBAAA;EAEJ;AACF;AADI;EA3BF;IA4BI,gBAAA;IACA,mBAAA;IACA,oBAAA;EAIJ;AACF;AAHI;EAhCF;IAiCI,cAAA;IACA,mBAAA;IACA,oBAAA;EAMJ;AACF;;AAHA;EACE,gBAAA;EACA,mBAAA;AAMF;;AAJA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;AAOF;AANE;EARF;IASI,eAAA;EASF;AACF;;AAPA;EACE,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAUF;;AALA;EACE,uMAAA;EAQA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;AACF","sourcesContent":[".digitalRev {\n  background: #1d1a36;\n  display: flex;\n  justify-content: center;\n  color: #fff;\n  // padding-top:2vw;\n  font-size: 3vw;\n  @media (max-width: 1024px) {\n    font-size: 5vw;\n    padding-top: 7vw;\n  }\n  @media (max-width: 992px) {\n    font-size: 7vw;\n    padding-top: 7vw;\n  }\n  @media (max-width: 768px) {\n    font-size: 7vw;\n    padding-top: 7vw;\n  }\n  @media (max-width: 576px) {\n    font-size: 8vw;\n    padding-top: 7vw;\n  }\n}\n\n.boxHeading {\n  // padding: 6vw 0vw 0vw 0vw;\n  background: #1d1a36;\n  display: flex;\n  justify-content: center;\n  color: #fff;\n  // padding-bottom: 2vw;\n}\n.headingParagraph {\n  // padding-left: 5vw;\n  // padding-right: 5vw;\n  // padding-bottom: 5vw;\n  background: #1d1a36;\n  display: flex;\n  text-align: center;\n  color: #fff;\n  font-size: 1.3vw;\n  line-height: 150%;\n  @media (max-width: 1200px) {\n    font-size: 16px;\n  }\n}\n.coreValues {\n  background: #1d1a36;\n  display: flex;\n  justify-content: center;\n  color: #fff;\n  padding-bottom: 2.5vw;\n}\n\n// AboutUs_gradiantHeading\n.AboutUs {\n  &_gradiantHeading {\n    border: 1px solid transparent;\n    border-image: linear-gradient(\n      146deg,\n      rgba(255, 182, 160, 1) 0%,\n      rgba(240, 89, 42, 1) 26%,\n      rgba(37, 60, 119, 1) 100%\n    );\n    border-image-slice: 1;\n    padding: 0.6rem;\n    //   margin: 1rem;\n    font-weight: 400;\n    font-family: Roboto;\n    font-size: 1.5vw;\n    text-align: center;\n    color: #fff;\n\n    @media (max-width: 1300px) {\n      font-size: 1.7vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 992px) {\n      font-size: 2vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 769px) {\n      font-size: 2.5vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 4vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n  }\n}\n.cardsAboutus {\n  padding-top: 2vw;\n  background: #1d1a36;\n}\n.missionText {\n  background: #1d1a36;\n  display: flex;\n  text-align: center;\n  color: #fff;\n  padding: 3vw 5vw 2vw 5vw;\n  line-height: 150%;\n  font-size: 1.3vw;\n  @media (max-width: 1200px) {\n    font-size: 16px;\n  }\n}\n.successAboutUs {\n  width: 60vw !important;\n  height: 30vw !important;\n  flex-shrink: 0;\n  border-radius: 20px;\n  background: #1d1a36;\n  // background:  lightgray 50% / cover no-repeat;\n  // margin-bottom: 8vw;\n}\n\n.NTAAboutUs {\n  background: linear-gradient(\n    270deg,\n    rgba(255, 136, 96, 0) 0%,\n    rgba(255, 190, 113, 0.4) 33.12%,\n    rgba(255, 153, 101, 0.4) 52.4%,\n    rgba(255, 225, 123, 0.4) 69.48%,\n    rgba(255, 242, 129, 0) 100%\n  ) !important;\n  width: 35vw !important;\n  height: 0.14vh !important;\n  margin: 1vh 0 6vh;\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
